import React, { Component } from 'react';
import cn from 'classnames';
import { LoadingSpinner } from './LoadingSpinner';
import styles from './Loading.scss';

export class LoadingScreen extends Component {
  render(){
    const { className, ...otherProps } = this.props;
    return (
      <div className={cn(styles.screen, className)} {...otherProps}>
        <LoadingSpinner size="lg"/>
      </div>
    );
  }
}
